/** 서비스 데이터 */
export class GetBrgMapAddressList {
    /** 페이지 사이즈 */
    size = '1000';
    /** 페이지 번호 */
    page = 1;
    /** 지역 코드 */
    areaType = '';
    /** 동 */
    dong = '';
    /** 리 */
    ri = '';
    /** 주 번호 */
    mainLotNumber = '';
    /** 부 번호 */
    subLotNumber = '';
    constructor(data) {
        Object.assign(this, {
            areaType: data.areaTypeCode,
            dong: data.eupMyeonDong,
            ri: data.ri,
            mainLotNumber: data.mainLotNumber,
            subLotNumber: data.subLotNumber,
        });
    }
    /**
     * 서버 요청 데이터 생성
     */
    createReqBody() {
        return {
            size: this.size,
            page: this.page,
            areaType: this.areaType,
            dong: this.dong,
            ri: this.ri,
            mainLotNumber: this.mainLotNumber,
            subLotNumber: this.subLotNumber,
        };
    }
}
